import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.footer`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 auto;
  max-width: ${props => props.theme.sizes.maxWidth};
`

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  border-top: 1px solid ${props => props.theme.colors.secondary};
  padding: 1em 0 2em;
  margin: 0 1.5em;
`

const Item = styled.li`
  display: inline-block;
  padding: 0.25em 0;
  width: 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    width: auto;
  }
  a {
    font-weight: 600;
    transition: all 0.2s;
    color: ${props => props.theme.colors.text};
    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
    &:visited {
      color: ${props => props.theme.colors.text};
    }
  }
`

const Footer = () => (
  <Wrapper>
    <List>
      <Item>
        <a
          href="https://t.me/z2hnews"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          <img
            src="https://images.ctfassets.net/tnc0qeknyjpq/41woBUSviiU8AL9bDSUS7X/6567d2ab044e095be7ff1818baeff726/powered.svg"
            style={{ width: '100px' }}
            alt="Powered by Z2H Tech"
          />
        </a>
      </Item>
      <Item>
        <a
          href="https://medium.com/i-am-only-human/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Taric
        </a>{' '}
        Made{' '}
          with ❤️
          in Vancouver
      </Item>
    </List>
  </Wrapper>
)

export default Footer
